module.exports = __webpack_public_path__ + "static/media/U1-T2-2-4b.07fcceb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-4b.svg
// module id = 557
// module chunks = 0